
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { UserPermissionAdminService } from 'src/app/shared/services/user-permission-admin.service';

@Component({
  selector: 'app-add-modal',
  imports: [
    FormsModule,
    InputText,
    ButtonModule
],
  templateUrl: './add-modal.component.html',
  styleUrl: './add-modal.component.scss'
})
export class AddModalComponent {
  public type: 'user' | 'group' = 'group';
  protected name: string = '';
  protected email: string = '';

  constructor(
    protected bsModalRef: BsModalRef,
    protected permissionService: UserPermissionAdminService
  ) { }

  protected cancel() {
    this.name = this.email = '';
    this.bsModalRef.hide();
  }

  protected async add() {
    if (this.type === 'group') {
      await this.permissionService.addGroupToProject(this.name.trim());
    } else {
      await this.permissionService.addUserToProject(this.name.trim(), this.email.trim());
    }
    this.name = this.email = '';
  }

  protected async addAndClose() {
    if (this.type === 'group') {
      await this.permissionService.addGroupToProject(this.name.trim());
    } else {
      await this.permissionService.addUserToProject(this.name.trim(), this.email.trim());
    }
    this.name = this.email = '';
    this.bsModalRef.hide();
  }

  protected checkInput(): boolean {
    if (this.name.trim() === '') return true;
    return false;
  }
}
